export function disposeStream(stream?: MediaStream) {
  if (!stream) {
    return;
  }

  if (stream.getVideoTracks && stream.getAudioTracks) {
    stream.getVideoTracks().forEach((track) => track.stop());
    stream.getAudioTracks().forEach((track) => track.stop());
  } else if (stream.getTracks) {
    // @see https://developer.mozilla.org/en-US/docs/Web/API/MediaStream/getTracks
    stream.getTracks().forEach((track) => track.stop());
  } else if (stream.stop) {
    stream.stop();
  }
}
